import { useState, type FormEvent } from "react";
import { useTranslation } from "@i18n/hooks";
import { type TransferLicenseFormProps } from "./transfer-license-form.types";
import { SearchableAccountTable } from "../../accounts/searchable-account-table";
import { type SearchableAccountTableSelection } from "../../accounts/searchable-account-table/searchable-account-table.types";

export const TransferLicenseForm = ({
	onSubmit,
	onCancel,
	isSubmitting,
	currentAccountId,
}: TransferLicenseFormProps) => {
	const { t } = useTranslation("common");
	const [selectedAccount, setSelectedAccount] = useState<
		SearchableAccountTableSelection | undefined
	>(undefined);

	const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		if (selectedAccount) {
			onSubmit({
				id: selectedAccount.id,
				name: selectedAccount.name,
			});
		}
	};

	return (
		<form onSubmit={handleSubmit}>
			<div className="mb-3">
				<label className="block mb-2">{t("licenses.targetAccount")}</label>
				{selectedAccount ? (
					<div className="flex align-items-center mb-2">
						<div className="flex-1 flex bg-gray-100 border-gray-300 border-1 border-round px-3 py-2">
							{selectedAccount.name}
						</div>
						<button
							type="button"
							className="p-button p-component p-button-secondary ml-2"
							onClick={() => setSelectedAccount(undefined)}
							disabled={isSubmitting}
						>
							×
						</button>
					</div>
				) : (
					<div className="mb-2">
						<SearchableAccountTable
							selectionMode="single"
							selection={selectedAccount ?? undefined}
							excludeAccountIds={currentAccountId ? [currentAccountId] : undefined}
							onChange={(account) => {
								if (account && !Array.isArray(account)) {
									setSelectedAccount(account);
								}
							}}
						/>
					</div>
				)}
			</div>
			<div className="flex justify-content-end mt-3">
				{onCancel && (
					<button
						type="button"
						className="p-button p-component p-button-secondary mr-2"
						onClick={onCancel}
						disabled={isSubmitting}
					>
						{t("actions.cancel")}
					</button>
				)}
				<button
					type="submit"
					className="p-button p-component"
					disabled={isSubmitting || !selectedAccount}
				>
					{isSubmitting ? t("licenses.transferring") : t("licenses.transfer")}
				</button>
			</div>
		</form>
	);
};
